import SlsRepresentanteClient from '@/api/Cadastros/ApoioVendas/sls-representante.client';
import Store from '@/store';

import { ErrorMessage } from '@/libs/Error';

export default class SLSRepresentanteService {
  constructor() {
    this.client = new SlsRepresentanteClient();
    this.store = Store;
    this.error = new ErrorMessage();
  }

  async index(queries) {
    try {
      const { data } = await this.client.index(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os representante');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.client.store(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao criar Representante');
    }
  }

  async show(id) {
    try {
      return await this.client.show(id);
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Representante');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.client.update(id, data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar Representante');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.client.destroy(id);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Representante');
    }
  }

  async listarRepresentanteInfoPedido(queries = this.store.getters['SLSRepresentante/filters']) {
    if (this.store.state.SLSRepresentante.isLoading) return;

    this.store.commit('SLSRepresentante/SET_LOADING', true);
    try {
      const { data: { data, ...pagination } } = await this.client.listarRepresentanteInfoPedido(queries);

      this.store.commit('SLSRepresentante/SET_REPRESENTANTES_E_PAGINACAO', {
        data,
        pagination: {
          total: pagination.total,
          page: pagination.current_page,
          perPage: pagination.per_page,
        },
      });

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      this.store.commit('SLSRepresentante/SET_LOADING', false);
    }
  }

  async listarRepresentanteByClienteIdERP(clienteiderp) {
    try {
      console.log('Buscando representante para cliente:', clienteiderp);
      const data = await this.client.listarRepresentanteByClienteIdERP(clienteiderp);
      console.log('Dados do representante recebidos:', data.data[0]);

      if (Array.isArray(data) && data.length > 0) {
        return data[0];
      }

      const representante = data.data[0];

      return representante;
    } catch (error) {
      console.error('Erro ao buscar representante do cliente:', error);
      this.error.message(error, 'Erro ao buscar representante do cliente');
      return null;
    }
  }
}
